"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tab = void 0;
var react_1 = __importStar(require("react"));
var react_jss_1 = require("react-jss");
var TabHead_1 = __importDefault(require("./TabHead"));
var useStyles = (0, react_jss_1.createUseStyles)(function (_a) {
    var colors = _a.colors;
    return ({
        tabHeads: function (_a) {
            var align = _a.align, hideBottomBorder = _a.hideBottomBorder;
            return ({
                userSelect: 'none',
                padding: '0 8px',
                marginBottom: 30,
                borderBottom: "1px solid ".concat(hideBottomBorder ? 'transparent' : colors.Grey[200]),
                display: 'flex',
                justifyContent: align === 'center' ? 'center' : align === 'left' ? null : 'flex-end',
            });
        },
    });
});
var Tabs = function (props) {
    var children = props.children, defaultTab = props.defaultTab, onChange = props.onChange;
    var styles = useStyles(props);
    var _a = (0, react_1.useState)(defaultTab), active = _a[0], setActive = _a[1];
    (0, react_1.useEffect)(function () {
        props.current !== undefined && handleTabClick(props.current);
    }, [props.current]);
    var tabs = (0, react_1.useMemo)(function () {
        return react_1.Children.map(children, function (child, index) {
            if (!(0, react_1.isValidElement)(child))
                return;
            var _a = child.props, label = _a.label, badge = _a.badge, _b = _a.id, id = _b === void 0 ? index : _b;
            var component = (0, react_1.cloneElement)(child, { active: index === active });
            return { label: label, badge: badge, id: id, component: component };
        });
    }, [children, active]);
    var handleTabClick = function (index) {
        if (index !== active) {
            setActive(index);
            onChange && onChange(index);
        }
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: styles.tabHeads }, tabs === null || tabs === void 0 ? void 0 : tabs.map(function (_a, index) {
            var label = _a.label, badge = _a.badge, id = _a.id;
            return (react_1.default.createElement(TabHead_1.default, { onClick: function () { return !props.disabled && handleTabClick(index); }, key: id, label: label, badge: badge, active: index === active }));
        })),
        react_1.default.createElement("div", null, tabs === null || tabs === void 0 ? void 0 : tabs.map(function (_a) {
            var component = _a.component, id = _a.id;
            return (react_1.default.createElement("div", { key: id }, component));
        }))));
};
Tabs.defaultProps = {
    defaultTab: 0,
    align: 'left',
};
var Tab_1 = require("./Tab");
Object.defineProperty(exports, "Tab", { enumerable: true, get: function () { return __importDefault(Tab_1).default; } });
exports.default = Tabs;
//# sourceMappingURL=index.js.map